import React, { useState } from "react";
import MuiAccordion from "@material-ui/core/Accordion";
import MuiAccordionSummary from "@material-ui/core/AccordionSummary";
import MuiAccordionDetails from "@material-ui/core/AccordionDetails";
import { Grid, Typography, makeStyles, withStyles } from "@material-ui/core";
import ExpandMoreIcon from "@material-ui/icons/ExpandMore";
import { useSelector } from "react-redux";
import "./_wrap.css"
import moment from "moment";

const useStyle = makeStyles((theme) => ({
  accordionMargin: {
    padding: "0.3rem 0.6rem",
    width: "99% !important",
  },
  accordionSmall: {
    padding: "0.3rem 0",
    width: "98% !important",
  },
}));

const Accordion = withStyles((theme) => ({
  root: {
    border: "1px solid " + theme.palette.eLight?.base,
    boxShadow: "none",
    "&:not(:last-child)": {
      borderBottom: 0,
    },
    "&:before": {
      display: "none",
    },
    "&$expanded": {
      margin: "auto",
    },
  },
  expanded: {},
}))(MuiAccordion);

const AccordionSummary = withStyles((theme) => ({
  root: {
    borderBottom: "1px solid " + theme.palette.eLight?.base,
    marginBottom: -1,
    minHeight: "auto",
    height: "37px",
    "&$expanded": {
      minHeight: 40,
    },
  },
  content: {
    margin: "0% 1%",
    width: "80%",
    "&$expanded": {
      margin: "0% 1%",
    },
  },
  expanded: {
    height: "auto",
  },
}))(MuiAccordionSummary);

const AccordionDetails = withStyles((theme) => ({
  root: {
    padding: "8px 17px",
  },
}))(MuiAccordionDetails);

export default function CardAccordion({ item, k }) {
  let classes = useStyle();
  const [expanded, setExpanded] = useState(false);
  const browserName = useSelector((store) => store?.browserDetect?.browserName);

  const handleChange = (panel) => (event, isExpanded) => {
    setExpanded(isExpanded ? panel : false);
  };
  return (
    <Grid item className={classes.accordionMargin} xs={12}>
      <Accordion expanded={expanded === k} onChange={handleChange(k)}>
        <AccordionSummary
          expandIcon={<ExpandMoreIcon />}
          aria-controls="panel1a-content"
          id={k}
        >
          <Typography variant="subtitle2" className={expanded != k ? 'wrapinline' :''} align="left">
          {item?._source?.ContentStartDate?moment(item?._source?.ContentStartDate).format('DD-MM-YYYY'):""}
          &nbsp;-&nbsp; {item?._source?.ContentTitle}
          </Typography>
        </AccordionSummary>
        <AccordionDetails
          style={{
            overflowY: browserName === "firefox" ? "auto" : "overlay",
          }}
        >
          {item._source.ContentGroupValue === "TEXT" ? (
            <Typography variant="subtitle2" >{item?._source?.ContentValue}</Typography>
          ) : (
            <Typography
            variant="subtitle2" 
              align="center"
              dangerouslySetInnerHTML={{
                __html: item?._source?.ContentValue,
              }}
            />
          )}
        </AccordionDetails>
      </Accordion>
    </Grid>
  );
}
